import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import NavbarPag from "../../components/NavbarPag";
import { es } from "date-fns/locale/es";
import { useData } from "../../contexts/DataContext";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../atoms/loading";
import Modal from "../../atoms/modal";
import db from "../../firebase";
import * as XLSX from "xlsx";
import {
  collection,
  onSnapshot,
  query,
  where,
  getDocs,
  Query,
  DocumentData,
} from "firebase/firestore";
import { AgGridReact } from "ag-grid-react";
import Dropdown from "../../atoms/dropdown";

interface Option {
  value: string;
  label: string;
}

interface Data {
  doc: string;
  field: string;
  where: number;
}

const Report = () => {
  // Estados posibles
  let lisState = ["INICIAL", "RETIRADO", "ENTREGADO", "NO ENTREGADO"];

  // === Helpers (CAMBIOS MÍNIMOS) ===
  const displayState = (s: string) => (s === "INICIAL" ? "EN RUTA" : s);

  const formatDMY = (d: any) => {
    // d puede venir como Firestore Timestamp, Date o string
    let date: Date;
    if (d && typeof d.toDate === "function") {
      date = d.toDate();
    } else if (d instanceof Date) {
      date = d;
    } else {
      date = new Date(d);
    }
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const [errorOd, setErrorOd] = useState(true);
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [titel, setTitel] = useState("");
  const [textButton, setTextButton] = useState("Cerrar");
  const location = useLocation();
  const [emailSearche, setEmailSearche] = useState("");
  const [lisNameUser, setLisNameUser] = useState<{ [key: string]: string }>({});
  const { setOd, profile } = useData();

  const [nameClient, setNameClient] = useState<Option[]>([
    { label: "todos", value: "todos" },
  ]);
  const [colDefs, setColDefs] = useState([
    { field: "FECHA" },
    { field: "GUIA" },
    { field: "OD" },
    { field: "ESTADO" },
    { field: "CLIENTE" },
    { field: "DESTINATARIO" },
    { field: "CIUDAD" },
    { field: "DESTINO" },
    { field: "DIRECCION" },
    { field: "BULTOS" },
    { field: "KILOS" },
    { field: "LARGO" },
    { field: "ANCHO" },
    { field: "ALTO" },
    { field: "CENTRO_DE_COSTOS" },
    { field: "OBSERVACIONES" },
  ]);

  const { rutInit, od } = useData();

  const navigate = useNavigate();
  useEffect(() => {
    initData();
    if (rutInit === "") {
      navigate("/");
    }
  }, []);

  const initData = async () => {
    const dataName: Option[] = [];
    let lisUser: { [key: string]: string } = {};
    const q = query(collection(db, "users"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let email = doc.data()["email"];
      let name = doc.data()["name"];
      dataName.push({ value: email, label: name });
      lisUser = { ...lisUser, [email]: name };
    });
    setNameClient(dataName);
    setLisNameUser(lisUser);
  };

  // Rango de fechas por defecto (hoy)
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    date.setHours(23, 59, 59, 999);
    return date;
  });

  const crear = async () => {
    let q: Query<DocumentData, DocumentData>;
    if (profile !== "" && profile !== undefined) {
      q =
          emailSearche !== ""
              ? query(
                  collection(db, "orders"),
                  where("email", "==", emailSearche),
                  where("time", ">=", startDate),
                  where("time", "<=", endDate)
              )
              : query(
                  collection(db, "orders"),
                  where("time", ">=", startDate),
                  where("time", "<=", endDate)
              );
    } else {
      q = query(
          collection(db, "orders"),
          where("email", "==", location.state.email),
          where("time", ">=", startDate),
          where("time", "<=", endDate)
      );
    }
    const querySnapshot = await getDocs(q);

    const docsArray = querySnapshot.docs;
    let dataView: any = [];
    for (let i = 0; i < docsArray.length; i++) {
      const uuid = docsArray[i].data()["uuid"];
      const qt = query(collection(db, "deliveries"), where("uuid", "==", uuid));
      const dataState = await getDocs(qt);
      dataState.forEach((doc) => {
        // === CAMBIO: FECHA formateada dd/MM/yyyy usando "time" ===
        const fechaFormateada = formatDMY(docsArray[i].data()["time"]);

        const estadoCrudo = lisState[doc.data()["state"]];
        const estadoMostrar = displayState(estadoCrudo);

        const dataOrden = {
          FECHA: fechaFormateada,
          GUIA: docsArray[i].data()["guia"],
          OD: docsArray[i].data()["uuid"],
          ESTADO: estadoMostrar,
          CLIENTE: lisNameUser[docsArray[i].data()["email"]],
          DESTINATARIO: docsArray[i].data()["destinatario"],
          CIUDAD: docsArray[i].data()["ciudad"],
          DESTINO: docsArray[i].data()["Destino"],
          DIRECCION: docsArray[i].data()["direccion"],
          BULTOS: docsArray[i].data()["bultos"],
          KILOS: docsArray[i].data()["kilos"],
          LARGO: docsArray[i].data()["largo"],
          ANCHO: docsArray[i].data()["ancho"],
          ALTO: docsArray[i].data()["alto"],
          CENTRO_DE_COSTOS: docsArray[i].data()["Centro_de_costos"],
          OBSERVACIONES: docsArray[i].data()["observaciones"],
        };
        dataView.push(dataOrden);
      });
    }
    setOrders(dataView);
  };

  registerLocale("es", es);

  const descargar = () => {
    if (orders.length === 0) return;
    const data = [
      [
        "FECHA",
        "GUIA",
        "OD",
        "ESTADO",
        "CLIENTE",
        "DESTINATARIO",
        "CIUDAD",
        "DESTINO",
        "DIRECCION",
        "BULTOS",
        "KILOS",
        "LARGO",
        "ANCHO",
        "ALTO",
        "CENTRO_DE_COSTOS",
        "OBSERVACIONES",
      ],
    ];
    orders.forEach((e) => {
      data.push([
        e.FECHA, // ← ya viene dd/MM/yyyy
        e.GUIA,
        e.OD,
        e.ESTADO,
        e.CLIENTE,
        e.DESTINATARIO,
        e.CIUDAD,
        e.DESTINO,
        e.DIRECCION,
        e.BULTOS,
        e.KILOS,
        e.LARGO,
        e.ANCHO,
        e.ALTO,
        e.CENTRO_DE_COSTOS,
        e.OBSERVACIONES,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Nombre de archivo con rango en dd-MM-yyyy (opcional)
    const fileName = `${formatDMY(startDate).replaceAll("/", "-")}_a_${formatDMY(
        endDate
    ).replaceAll("/", "-")}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const getCliente = (data: string) => {
    setEmailSearche(data.split(":")[0]);
  };

  return (
      <div className={errorOd ? "w-screen   bg-neutral-200" : ""}>
        {showModal && (
            <Modal
                message={message}
                titel={titel}
                onClick={() => setShowModal(false)}
                textButton={textButton}
            />
        )}
        {loading && <Loading />}
        <NavbarPag />

        <div className=" h-full bg-neutral-200 flex flex-col items-center">
          <div className=" w-11/12">
            <h2 className="text-2xl text-center p-3"> Reporte de envíos</h2>

            <article className=" bg-slate-50">
              <div className="flex p-4">
                <div className="pr-8 pt-2">Fecha de Inicio</div>
                <DatePicker
                    selected={startDate}
                    onChange={(date: any) => setStartDate(date)}
                    locale="es"
                    dateFormat="dd/MM/yyyy"   // ← CAMBIO: formato visible
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                />
                <div className="pr-8 pt-2">Fecha de final</div>
                <DatePicker
                    selected={endDate}
                    onChange={(date: any) => setEndDate(date)}
                    locale="es"
                    dateFormat="dd/MM/yyyy"   // ← CAMBIO: formato visible
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                />
                {profile !== "" && profile !== undefined ? (
                    <div className="pr-8 pt-2">Usuario</div>
                ) : (
                    ""
                )}

                {profile !== "" && profile !== undefined ? (
                    <Dropdown
                        primariOptions="-- Todos --"
                        label=""
                        options={nameClient}
                        onSelect={getCliente}
                        class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
                    />
                ) : (
                    ""
                )}
              </div>
              <div className="flex p-4">
                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-10 mb-5"
                    onClick={crear}
                >
                  Crear Reporte
                </button>
                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-10 mb-5"
                    onClick={descargar}
                >
                  Descargar Reporte
                </button>
              </div>
            </article>

            <article className=" h-[45rem] pt-7">
              <div className="ag-theme-quartz" style={{ height: "65%" }}>
                <AgGridReact rowData={orders} columnDefs={colDefs} />
              </div>
            </article>
          </div>
        </div>
      </div>
  );
};

export default Report;
